export function formatLocalDate(
  dateOrStr: Date | string | undefined,
  dateFormat: "full" | "long" | "medium" | "short"
) {
  const date = typeof dateOrStr === "string" ? new Date(dateOrStr) : dateOrStr
  if (!date) {
    return ""
  }
  return date.toLocaleDateString(undefined, {
    dateStyle: dateFormat,
  })
}

export function formatLocalTime(
  dateOrStr: Date | string | undefined,
  timeFormat: "full" | "long" | "medium" | "short"
) {
  const date = typeof dateOrStr === "string" ? new Date(dateOrStr) : dateOrStr
  if (!date) {
    return ""
  }
  return date.toLocaleTimeString(undefined, {
    timeStyle: timeFormat,
  })
}

export function formatLocalDateTime(
  dateOrStr: Date | string | undefined,
  dateFormat: "full" | "long" | "medium" | "short",
  timeFormat: "full" | "long" | "medium" | "short"
) {
  return formatLocalDate(dateOrStr, dateFormat) + " " + formatLocalTime(dateOrStr, timeFormat)
}
